import { isEdu } from 'owa-nonboot-userconfiguration-manager';
import { isFeatureEnabled } from 'owa-feature-flags';

export function isWovenNewTabExperimentEnabled() {
    return isFeatureEnabled('woven-newTabExperiment') && isEdu();
}
